<template>
    <vs-popup :title="`مراجعة طباعة نموذج (${data && data.title})`" class="question-bank-printer" :active="active" @close="close">
        <div v-if="active" class="document-editor">
            <div id="ck_toolbar" class="document-editor__toolbar"></div>
            <div id="ck_content" class="document-editor__editable-container">
                <ckeditor refs="editor" class="document-editor__editable-container" :editor="editor" @ready="onReady" v-model="editorContent" :config="editorConfig"/>
            </div>
        </div>
        <div dir="rtl" id="elementH"></div>
        <div class="mt-2 flex justify-end">
            <vs-button class="mr-2" type="flat" @click="close">رجوع</vs-button>
            <vs-button @click="print">حفظ</vs-button>
        </div>
    </vs-popup>
</template>

<script>
    import CKEditor from '@ckeditor/ckeditor5-vue'
    import DecopledDocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document'
    import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/ar'

    export default {
        name: 'QuestionBankPrinter',
        components: {
            ckeditor: CKEditor.component
        },
        props: {
            data: {
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            active(val) {
                if(!val) return
                let temp = `<h2 style="text-align:center;">${this.data.title}</h2>`
                this.data.questions.forEach((question, index) => {
                    temp += `<p>السؤال ${index+1}. (${question.mark})</p>`
                    temp += `${question.title}`
                    if (question.type === 'choices' || question.type === 'true/false'){
                        temp += '<ul class="todo-list">'
                        question.choices.forEach(c => {
                            temp += `<li><label class="todo-list__label"><input type="checkbox" readonly></label>${c.choice_title}</li>`
                        })
                        temp += '</ul>'
                    } else {
                        temp += '<hr><hr><hr><hr>'
                    }
                })
                this.editorContent = temp
            }
        },
        data () {
            return {
                editorContent: '',
                editor: DecopledDocumentEditor,
                editorConfig: {
                    toolbar: ["heading", "|", "fontsize", "fontColor", "fontBackgroundColor", "|",
                        "bold", "italic", "underline", "strikethrough", "|", "alignment", "|",
                        "numberedList", "bulletedList", "|", "undo", "redo"],
                    language: 'ar',
                }
            }
        },
        methods: {
            onReady(editor)  {
                // Insert editor toolbar before the editable area
                document.getElementById('ck_toolbar').append(editor.ui.view.toolbar.element)
                document.getElementById('ck_content').append(editor.ui.getEditableElement())

                // Set focus on the editor body
                editor.sourceElement.focus()
            },
            print() {
                const printLayout = document.createElement('div');
                printLayout.setAttribute('id', 'print_content')
                printLayout.setAttribute('class', 'ck ck-content')
                printLayout.innerHTML = this.editorContent
                document.body.appendChild(printLayout)
                window.print()
                document.body.removeChild(printLayout)
            },
            close(){
                this.$emit('update:active', false)
            },
        },
    }
</script>

<style lang="scss">
    @media print {
        body * {
            visibility: hidden;
        }
        #print_content, #print_content * {
            visibility: visible;
        }
        #print_content {
            display: block !important;
            position: absolute;
            top: 0;
            left: 0;
            padding: 2.5rem;
            width: 100%;
            height: auto;
            overflow: visible;
        }
        hr {
            display: block !important;
            height: 1px !important;
            background: transparent !important;
            width: 100% !important;
            border: none !important;
            padding: 10px 0 !important;
            border-bottom: solid 1px #aaa !important;
        }
        p {
            padding-top: 1rem !important;
        }
    }
    .question-bank-printer {
        .vs-popup {
            width: 60rem;
        }
        hr {
            margin: 5px 0;
            height: 1px !important;
            background: #aaa;
        }
        p {
            margin-top: 1rem;
        }
        .document-editor {
            border: 1px solid var(--ck-color-base-border);
            border-radius: var(--ck-border-radius);

            /* Set vertical boundaries for the document editor. */
            max-height: 700px;

            /* This element is a flex container for easier rendering. */
            display: flex;
            flex-flow: column nowrap;
        }
        .document-editor__toolbar {
            /* Make sure the toolbar container is always above the editable. */
            z-index: 1;

            /* Create the illusion of the toolbar floating over the editable. */
            box-shadow: 0 0 5px hsla( 0,0%,0%,.2 );

            /* Use the CKEditor CSS variables to keep the UI consistent. */
            border-bottom: 1px solid var(--ck-color-toolbar-border);
        }

        /* Adjust the look of the toolbar inside the container. */
        .document-editor__toolbar .ck-toolbar {
            border: 0;
            border-radius: 0;
        }
        /* Make the editable container look like the inside of a native word processor application. */
        .document-editor__editable-container {
            padding: calc( 2 * var(--ck-spacing-large) );
            background: var(--ck-color-base-foreground);

            /* Make it possible to scroll the "page" of the edited content. */
            overflow-y: scroll;
        }

        .document-editor__editable-container .ck-editor__editable {
            overflow: hidden;
            /* Set the dimensions of the "page". */
            width: 15.8cm;
            min-height: 21cm;

            /* Keep the "page" off the boundaries of the container. */
            padding: 1cm 2cm 2cm    ;

            border: 1px hsl( 0,0%,82.7% ) solid;
            border-radius: var(--ck-border-radius);
            background: white;

            /* The "page" should cast a slight shadow (3D illusion). */
            box-shadow: 0 0 5px hsla( 0,0%,0%,.1 );

            /* Center the "page". */
            margin: 0 auto;
        }
        /* Set the default font for the "page" of the content. */
        .document-editor .ck-content,
        .document-editor .ck-heading-dropdown .ck-list .ck-button__label {
            font: 16px/1.6 "Helvetica Neue", Helvetica, Arial, sans-serif;
        }
        /* Adjust the headings dropdown to host some larger heading styles. */
        .document-editor .ck-heading-dropdown .ck-list .ck-button__label {
            line-height: calc( 1.7 * var(--ck-line-height-base) * var(--ck-font-size-base) );
            min-width: 6em;
        }

        /* Make the block quoted text serif with some additional spacing. */
        .document-editor .ck-content blockquote {
            font-family: Georgia, serif;
            margin-left: calc( 2 * var(--ck-spacing-large) );
            margin-right: calc( 2 * var(--ck-spacing-large) );
        }
    }
</style>
